"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = connect;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _eventEmitter = _interopRequireDefault(require("../Base/views/eventEmitter.c"));

var _dataModel = _interopRequireDefault(require("../../common/backbone/dataModel"));

var _dataCollection = _interopRequireDefault(require("../../common/backbone/dataCollection"));

var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
* usage example
*
* connectStore({
*   nameOfModel: Model,
    nameOfCll: Collection,
    secondNameOfCll: Collection.getInstance(),
    nameOfModelWithAttr: {store: Model, attribute: 'attributeName'},
* })
* (Component)
*
* */
var ConnectStore =
/*#__PURE__*/
function (_EventEmitter) {
  (0, _inherits2["default"])(ConnectStore, _EventEmitter);

  function ConnectStore(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ConnectStore);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ConnectStore).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_bind", function () {
      if (_this.storageList && (0, _typeof2["default"])(_this.storageList) === 'object') {
        var storeName;

        for (storeName in _this.storageList) {
          if (_this.storageList.hasOwnProperty(storeName)) {
            var item = _this.storageList[storeName];

            if (item instanceof _dataModel["default"] || item instanceof _dataCollection["default"]) {
              _this._listen(item);

              _this.propsStoreMap[storeName] = item;
            } else if (item.storage) {
              _this._listen(item.storage, item);

              _this.propsStoreMap[storeName] = item.storage;
            }
          }
        }
      }

      return (0, _assertThisInitialized2["default"])(_this);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_listen", function (storage) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (storage instanceof _dataModel["default"]) {
        if (typeof options.event === 'string') {
          _this.listenTo(storage, options.event, _this._handleStoreChange);
        } else if (options.attribute) {
          _this.listenTo(storage, "change:".concat(options.attribute), _this._handleStoreChange);
        } else {
          _this.listenTo(storage, 'change', _this._handleStoreChange);
        }
      } else if (storage instanceof _dataCollection["default"]) {
        if (typeof options.event === 'string') {
          _this.listenTo(storage, options.event, _this._handleStoreChange);
        } else {
          _this.listenTo(storage, 'all', (0, _debounce["default"])(_this._handleStoreChange, 200, {
            leading: true
          }));
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleStoreChange", function () {
      _this.iteration += 1;

      _this.setState({
        __connectIterationId: _this.id + _this.iteration
      });

      return (0, _assertThisInitialized2["default"])(_this);
    });
    var proto = Object.getPrototypeOf((0, _assertThisInitialized2["default"])(_this)),
        ctr = proto.constructor;
    _this.ComponentToWrap = ctr.ComponentToWrap;
    _this.storageList = ctr.storageList;
    _this.id = (0, _uniqueId2["default"])('connectStoreId');
    _this.iteration = 0;
    _this.propsStoreMap = {};

    _this._bind();

    return (0, _possibleConstructorReturn2["default"])(_this, (0, _assertThisInitialized2["default"])(_this));
  }

  (0, _createClass2["default"])(ConnectStore, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListening();
    }
  }, {
    key: "render",
    value: function render() {
      if (typeof this.ComponentToWrap === 'function') {
        return _react["default"].createElement(this.ComponentToWrap, _objectSpread({}, this.props, {}, this.propsStoreMap));
      } else {
        return null;
      }
    }
  }]);
  return ConnectStore;
}(_eventEmitter["default"]);

var connectFabric = function connectFabric(Component, storageList) {
  var _class, _temp;

  if (typeof Component !== 'function') {
    if (process && process.env.NODE_ENV !== 'production') {
      console.error("connectStore: cannot connect Constructor.");
    }

    return null;
  }

  return _temp = _class =
  /*#__PURE__*/
  function (_ConnectStore) {
    (0, _inherits2["default"])(_class, _ConnectStore);

    function _class() {
      (0, _classCallCheck2["default"])(this, _class);
      return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_class).apply(this, arguments));
    }

    return _class;
  }(ConnectStore), (0, _defineProperty2["default"])(_class, "ComponentToWrap", Component), (0, _defineProperty2["default"])(_class, "storageList", storageList), (0, _defineProperty2["default"])(_class, "displayName", "ConnectStore(".concat(Component.displayName || '', ")")), _temp;
};

function connect(storageList) {
  return function (Component) {
    return connectFabric(Component, storageList);
  };
}